import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Row } from "react-bootstrap";
import { formatMoeda, getUuidV4, goToFocus, handleNumberOnly, validarCNPJ, validarCPFCNPJ } from "../../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { DispInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import {
    addDispositivoValePedagio,
    removeDispositivoValePedagio,
    changeValePedCategoria,
    removeDispositivoValePedagioTodos
} from "../../../features/manifestoSlice";
import { useRef, useState } from "react";
import { ButtonRemover, ButtonTrash,  JTable, JTBody, JTHead } from "../../../components/Components";
import { TypeCategCombVeic } from "../../../lists";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";

const initialForm: DispInterface = {
    id: 0,
    CNPJForn: '',
    CPFCNPJPg: '',
    nCompra: '',
    vValePed: 0,
    tpValePed: '',
}

export default function ValePedagio() {
    const dispatch = useDispatch();
    const [selecionado, setSelecionado] = useState<number | string>('');
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.modal_rodoviario.infANTT.valePed);
    const [form, setForm] = useState<DispInterface>(initialForm);
    const cnpjFornRef = useRef<HTMLInputElement>(null);
    const cpfCnpjPgRef = useRef<HTMLInputElement>(null);
    const vValePedRef = useRef<HTMLInputElement>(null);
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();

    const validaPreenchimento = () => {

        if (form.CNPJForn === "") {
            goToFocus(cnpjFornRef);
            alertModal('Informe o CNPJ Fornecedor');
            return false;
        }

        if (!validarCNPJ(form.CNPJForn)) {
            goToFocus(cnpjFornRef);
            alertModal('CNPJ Fornecedor inválido.');
            return false;
        }

        if (form.CPFCNPJPg === "") {
            goToFocus(cpfCnpjPgRef);
            alertModal('Informe o CPF/CNPJ do responsável');
            return false;
        }

        if (!validarCPFCNPJ(form.CPFCNPJPg)) {
            goToFocus(cpfCnpjPgRef);
            alertModal('CPF/CNPJ do responsável inválido.');
            return false;
        }

        if (form.vValePed === 0 || form.vValePed.toString().trim() === "") {
            goToFocus(vValePedRef);
            alertModal('Informe o Vlr. do Vale Pedágio');
            return false;
        }

        if (lista.disp.find((item: DispInterface) =>
            item.CNPJForn === form.CNPJForn && item.CPFCNPJPg === form.CPFCNPJPg && item.nCompra === form.nCompra)) {
            alertModal('Nro comprovante já adicionado');
            return false;
        }

        return true;
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addDispositivoValePedagio({
                ...form,
                id: getUuidV4()
            }));
            setForm(initialForm);
        }
    }

    const handleChangeCategoria = (e: any) => {
        dispatch(changeValePedCategoria(e.target.value));
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id)
        const confirmed = await confirm({
            title: "Confirmação",
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>
        })

        if (confirmed) {
            dispatch(removeDispositivoValePedagio(value.id));
            setForm(initialForm);
        }
        setSelecionado('')
    }

    const removerTudo = async () => {
        if (lista.disp.length > 0) {
            const confirmed = await confirm({
                title: "Confirmação",
                message: <>Remover todos ?</>
            })
            if (confirmed) {
                goToFocus(cnpjFornRef);
                dispatch(removeDispositivoValePedagioTodos());
            }
        }
    }
    return (<>
        <Row className="mb-3">
            <Col md={4}>
                <Form.Group controlId="categCombVeic">
                    <Form.Label>Categoria de Combinação Veicular</Form.Label>
                    <Form.Select name="categCombVeic" value={lista.categCombVeic}
                        onChange={handleChangeCategoria}>
                        {TypeCategCombVeic.map(x => (
                            <option key={x.id} value={x.id}>{x.name}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
        </Row>
        <hr />
        <Row className="mb-3 g-2">
            <Col md={2}>
                <Form.Group controlId="CNPJForn">
                    <Form.Label>* CNPJ Fornecedor</Form.Label>
                    <Form.Control name="CNPJForn" value={form.CNPJForn} maxLength={14}
                        ref={cnpjFornRef}
                        onChange={handleChange} onKeyUp={handleNumberOnly} />
                </Form.Group>
            </Col>
            <Col md={2}>
                <Form.Group controlId="CPFCNPJPg">
                    <Form.Label>* CPF/CNPJ Responsável</Form.Label>
                    <Form.Control name="CPFCNPJPg" value={form.CPFCNPJPg} maxLength={14}
                        ref={cpfCnpjPgRef}
                        onChange={handleChange} onKeyUp={handleNumberOnly} />
                </Form.Group>
            </Col>
            <Col md={2}>
                <Form.Group controlId="nCompra">
                    <Form.Label>Nro. Comprovante</Form.Label>
                    <Form.Control name="nCompra" value={form.nCompra} onChange={handleChange} maxLength={20} />
                </Form.Group>
            </Col>
            <Col md={2}>
                <Form.Group controlId="vValePed">
                    <Form.Label>* Vlr. do Vale Pedágio</Form.Label>
                    <Form.Control name="vValePed" value={form.vValePed}
                        ref={vValePedRef}
                        onChange={(e) => {
                            setForm({
                                ...form,
                                vValePed: parseFloat(e.target.value.replace(/[^0-9.]/g, "").replace(/(\.\d{2})\d+/, "$1"))
                            })
                        }}
                        type="number" maxLength={16} min={0} />
                </Form.Group>
            </Col>
            <Col md>
                <Form.Group controlId="tpValePed">
                    <Form.Label>Tipo do Vale Pedagio </Form.Label>
                    <Form.Select name="tpValePed" onChange={handleChange} value={form.tpValePed}>
                        <option value="">Nao informado</option>
                        <option value="01">01 - TAG</option>
                        <option value="02">02 - Cupom</option>
                        <option value="03">03 - Cartão</option>
                    </Form.Select>
                </Form.Group>
            </Col>
            <Col md={'auto'} className="d-flex align-items-end">
                <Form.Group>
                    <Button type="button" title="Adicionar disponitivo na lista" onClick={handleAdd}>
                        <FontAwesomeIcon icon={faPlus} /> Adicionar
                    </Button>
                </Form.Group>
            </Col>
        </Row>

        <JTable>
            <JTHead>
                <tr>
                    <th className="text-center" style={{ width: '2.5rem' }}>
                        <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                    </th>
                    <th>CNPJ do fornecedor</th>
                    <th>CPF/CNPJ Responsável</th>
                    <th>Nro Comprov. Compra</th>
                    <th>Vlr. do Vale Pedágio</th>
                    <th>Tipo Vale Pedágio</th>
                </tr>
            </JTHead>

            <JTBody>
                {lista?.disp?.map((item: DispInterface) => (
                    <tr key={item.id} className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                        <td className="text-center">
                            <ButtonRemover onClick={() => handleRemover({ id: item.id, title: item.CNPJForn })} />
                        </td>
                        <td>{item.CNPJForn}</td>
                        <td>{item.CPFCNPJPg}</td>
                        <td>{item.nCompra}</td>
                        <td>{formatMoeda(item.vValePed, 2)}</td>
                        <td>{item.tpValePed}</td>
                    </tr>
                ))}
            </JTBody>
        </JTable>
        {ConfirmModal}
        {ModalMessageEl}
    </>)
}